import AkshayKumar from './../assets/actorsPhotos/akshayKumar.jpeg'
import SanjayDutt from './../assets/actorsPhotos/sanjayDutt.jpeg'
import SalmanKhan from './../assets/actorsPhotos/salmaKhan.jpeg'
import Govinda from './../assets/actorsPhotos/govinda.jpeg'
import MithunChakraborty from './../assets/actorsPhotos/mithun.jpeg'
import Dharmendra from './../assets/actorsPhotos/dharmendra.jpeg'
import Jeetendra from './../assets/actorsPhotos/jeetendra.jpeg'
import Sridevi from './../assets/actorsPhotos/sridevi.jpeg'
import AnilKapoor from './../assets/actorsPhotos/anilKapoor.jpeg'
import RajeshKhanna from './../assets/actorsPhotos/rajeshKhanna.jpeg'
import AmitabhBachchan from './../assets/actorsPhotos/amitabhBachchan.jpeg'
import RaveenTandon from './../assets/actorsPhotos/raveenaTandon.jpeg'

export const actorLocalData = [
    {
        id:11,
        name:'For You',
        image:""
    },
    {
        id: 1,
        name: "Akshay Kumar",
        image: AkshayKumar,
    },
    {
        id: 2,
        name: "Govinda",
        image: Govinda,
    },
    {
        id: 3,
        name: "Mithun Chakraborty",
        image: MithunChakraborty,
    },
    {
        id: 4,
        name: "Salman Khan",
        image: SalmanKhan,
    },
    {
        id: 5,
        name: "Sanjay Dutt",
        image: SanjayDutt,
    },
    {
        id: 5,
        name: "Dharmendra",
        image: Dharmendra,
    },
    {
        id: 6,
        name: "Jeetendra",
        image: Jeetendra,
    },
    {
        id: 7,
        name: "Sridevi",
        image: Sridevi,
    },
    {
        id: 8,
        name: "Anil Kapoor",
        image: AnilKapoor,
    },
    {
        id: 9,
        name: "Rajesh Khanna",
        image: RajeshKhanna,
    },
    {
        id: 10,
        name: "Amitabh Bachchan",
        image: AmitabhBachchan,
    },
    {
        id: 11,
        name: "Raveena Tandon",
        image: RaveenTandon,
    },
    
];